// Free history window, in months. Read from NEXT_PUBLIC_FREE_MONTHS_LIMIT, which
// must match FREE_MONTHS_LIMIT on the backend (tiny-texts-backend). NEXT_PUBLIC_
// values are baked in at build time, so changing it on Heroku needs a rebuild/
// redeploy of the website (a config change alone only restarts the app).
// A missing or invalid value falls back to the default. Valid = whole number 1-120.
const DEFAULT_FREE_MONTHS_LIMIT = 6;
const parseFreeMonthsLimit = (raw) => {
	const trimmed = typeof raw === 'string' ? raw.trim() : '';
	const n = Number(trimmed);
	return /^\d+$/.test(trimmed) && n >= 1 && n <= 120 ? n : DEFAULT_FREE_MONTHS_LIMIT;
};
// Must be the literal expression below so Next inlines it at build time.
export const FREE_MONTHS_LIMIT = parseFreeMonthsLimit(process.env.NEXT_PUBLIC_FREE_MONTHS_LIMIT);
// Human text for UI copy, e.g. "6 months" (singular when 1).
export const FREE_HISTORY_LABEL = `${FREE_MONTHS_LIMIT} ${FREE_MONTHS_LIMIT === 1 ? 'month' : 'months'}`;
export const FREE_HISTORY_TITLE = `${FREE_MONTHS_LIMIT} ${FREE_MONTHS_LIMIT === 1 ? 'Month' : 'Months'}`;

// The backend now does the filtering (guests: 16 latest in the free window, free: last FREE_MONTHS_LIMIT months,
// pro: everything) and never sends locked placeholders, so every message
// received is shown. Legacy `locked: true` items are still dropped defensively.
// Returns { visible, blurred, hiddenCount }; blurred/hiddenCount are always
// empty/0 and only kept so callers don't change shape.
export const applyPaywall = (messages) => {
	if (!Array.isArray(messages)) return { visible: [], blurred: [], hiddenCount: 0 };
	return {
		visible: messages.filter((m) => m?.locked !== true),
		blurred: [],
		hiddenCount: 0,
	};
};

// Whether to show the upgrade / sign-in card after the list.
// - Guest: any non-empty list. The backend caps guests and never says whether
//   more exist, so the sign-in card always follows what they can see.
// - Free: we reached the end of the list AND the backend says older messages
//   exist outside the free window (pagination.hasOlder). Nothing hidden, no card.
//   Pages whose endpoint sends no pagination (home, explore without a next
//   page flag) leave hasOlder undefined, so free users get no card there.
// - Pro: never.
// Fail stance: unknown state counts as not pro, so the card may show briefly
// while the account is still loading.
export const shouldShowPaywall = ({ user, isPro, count, hasNextPage, hasOlder }) => {
	if (isPro) return false;
	if (!user) return count > 0;
	return !hasNextPage && count > 0 && hasOlder === true;
};

export const PAYWALL_LIMITS = {
	FREE_MONTHS_LIMIT,
};
